/**
 * @file Unauthenticated Axios client for public APIs (landing, events, reference catalogs).
 */

import axios from "axios";
import { getApiBaseUrl } from "../config/apiConfig";

/** JSON client without auth interceptors — use for public endpoints only. */
const publicAxiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Content-Type": "application/json" },
});

/** Default export — public Axios Client. */
export default publicAxiosClient;
